import ServiceGraphQL from 'src/service/gql-service';
import { resendVerifyEmail, sendPhoneVerification, signup, verifyEmail, verifyPhone } from 'src/graphql';
import * as actionType from '../onBoard/ActionType';

const serviceGraphQL = new ServiceGraphQL();

export const setRegisterForm = (data) => ({
  type: actionType.SET_REGISTER_FORM,
  payload: data
});

export const Signup = (variables) => {
  const params = {
    query: signup.QUERY,
    variables
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res.data.signup;
    })
    .catch((err) => {
      throw err;
    });
};

export const ResendVerifyEmail = (variables) => {
  const params = {
    query: resendVerifyEmail.QUERY,
    variables
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const VerifyEmail = (variables) => {
  const params = {
    query: verifyEmail.QUERY,
    variables
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const VerifyPhone = (variables) => {
  const params = {
    query: verifyPhone.QUERY,
    variables
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const SendPhoneVerification = (variables) => {
  const params = {
    query: sendPhoneVerification.QUERY,
    variables
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
